import { initializeApp } from 'firebase/app'

const firebaseConfig = {
  apiKey: 'AIzaSyCanD3FY6E_J7DaGDwE9-4fD1rPjFUK9Hc',
  authDomain: 'thingtesting.com',
  databaseURL: 'https://thingtesting.firebaseio.com',
  projectId: 'thingtesting',
  storageBucket: 'thingtesting.appspot.com',
  messagingSenderId: '333633160166',
  appId: '1:333633160166:web:9d669f673a8c836c28cc27'
}

export const setupFirebase = () => {
  initializeApp(firebaseConfig)
}
